export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "to_verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["À vérifier"])},
        "nothing_to_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rien à signaler."])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Document pas encore analysé."])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyse indisponible"])},
        "see_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])},
        "see_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir moins"])},
        "column_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Champ"])},
        "column_verdict": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verdict"])},
        "column_reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raison"])},
        "verdict": {
          "PASS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conforme"])},
          "REVIEW": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["À vérifier"])},
          "FAIL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non conforme"])},
          "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indisponible"])}
        }
      },
      "en": {
        "to_verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To verify"])},
        "nothing_to_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nothing to report."])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Document not analyzed yet."])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analysis unavailable"])},
        "see_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["See more"])},
        "see_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["See less"])},
        "column_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Field"])},
        "column_verdict": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verdict"])},
        "column_reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reason"])},
        "verdict": {
          "PASS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compliant"])},
          "REVIEW": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To verify"])},
          "FAIL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non-compliant"])},
          "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unavailable"])}
        }
      }
    }
  })
}
